<!-- @format -->

<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
		<path
			fill="currentColor"
			d="M8 4q.55 0 1.063.145a3.94 3.94 0 0 1 1.762 1.031a3.94 3.94 0 0 1 1.03 1.762Q12 7.448 12 8q0 .55-.145 1.063a3.94 3.94 0 0 1-1.03 1.765a4 4 0 0 1-1.762 1.031Q8.55 12 8 12c-.55 0-.721-.047-1.063-.14a4.06 4.06 0 0 1-1.765-1.032A4.06 4.06 0 0 1 4.14 9.062A4 4 0 0 1 4 8q0-.55.14-1.063a4 4 0 0 1 .407-.953A4.1 4.1 0 0 1 5.98 4.546a4 4 0 0 1 .957-.401A4 4 0 0 1 8 4"
		/>
	</svg>
</template>
<script lang="ts">
	import type { DefineComponent } from 'vue';
	export default {
		name: 'menu-cricle',
	} as DefineComponent;
</script>
